import { render, staticRenderFns } from "./ItemAction.vue?vue&type=template&id=5cf4ec72&"
import script from "./ItemAction.vue?vue&type=script&lang=js&"
export * from "./ItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports